import { writable } from 'svelte/store';
import type { Brand } from '../types';
import { api } from '../api';

/** Seeds the "Hãng" filter chips (Rail.svelte). Empty until loadBrands() resolves;
 *  stays empty on failure — the filter degrades to a free-text box only. */
export const brands = writable<Brand[]>([]);

export async function loadBrands(): Promise<void> {
  try {
    const res = await api.brands();
    brands.set(res.brands);
  } catch {
    // non-fatal: brand chips are a convenience, not a requirement
  }
}
